/* eslint-disable */
const a16zPodcastImagePath = '/wp-content/themes/a16z/assets/images/podcast/';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { Scene, Group, WebGLRenderer, LoadingManager, TextureLoader, PerspectiveCamera, Vector2, Vector3, MathUtils, Sprite, SpriteMaterial } from "three";

class HeroA16ZPodcastShow {
  constructor() {
    this.originalRect = {width: 1680, height: 800, widthHalf: 840, heightHalf: 400};
    this.canvas = document.getElementById("podcast-canvas");
    this.root = document.getElementById("podcast-hero");
    this.mouseX = this.originalRect.widthHalf
    this.mouseY = this.originalRect.heightHalf
    this.imagePath = a16zPodcastImagePath;
    this.autoRotate = this.isTouchDevice();
    this.autoRotateSpeed = 0.0035;
    this.autoRotateAngle = 0;
    this.resize()
    this.initScene();
    this.initRenderer();
    this.initCamera();
    this.initVertexes();

    this.initMouseMove();
    this.render();
    this.handleResize();
  }

  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  initScene() {
    this.scene = new Scene();
  }

  initRenderer() {
    this.renderer = new WebGLRenderer({canvas: this.canvas, antialias: true, alpha: true});
    this.renderer.setSize(this.rootWidth, this.rootHeight);
    const context = this.renderer.getContext();
    const maxRenderBufferSize = context.getParameter(context.MAX_RENDERBUFFER_SIZE);

    this.pixelRatio = maxRenderBufferSize < 6000 ? 1 : window.devicePixelRatio;
    this.renderer.setPixelRatio(this.pixelRatio);
  }

  initCamera() {
    const originalAspect = this.originalRect.width / this.originalRect.height;
    const aspect = this.rootWidth / this.rootHeight;
    this.deltaAspect = originalAspect / aspect;

    this.camera = new PerspectiveCamera(75, aspect, 1, 50);
    if(this.deltaAspect < 1.5) {
      this.camera.position.set(0, 0, 7 * this.deltaAspect);
    } else {
      this.camera.position.set(0, 0, 13 - this.deltaAspect * 0.05);
    }
    this.camera.lookAt(0, 0, 0);
    this.camera.updateProjectionMatrix();
  }

  initObjects() {
    let vertexes = [];
    let id = 0;
    this.sceneGroup = new Group();
    this.scene.add(this.sceneGroup);
    this.updateGroup()

    this.circles.forEach(circle => {
      let x = (this.adjustCoordinatesX(circle) - this.originalRect.widthHalf) / 100;
      let y = (this.originalRect.heightHalf - circle.cy) / 100;
      let z = circle.z ? circle.z : Math.random() * 0.25 - 0.125;
      vertexes.push(new Vector3(x, y, z));

      if(circle.map) {
        const sprite = new Sprite(
          new SpriteMaterial({
            map: circle.map,
            alphaTest: 0.5,
          })
        );

        sprite.position.set(x, y, z + 0.14);
        sprite.scale.set(circle.radius, circle.radius, 1);
        this.sceneGroup.add(sprite);
      }
      id++;
    });
    this.vertexes = vertexes;

    this.initLines();
  }

  initVertexes() {
    const posBack4 = -0.8;
    const posBack3 = -0.6;
    const posBack2 = -0.4;
    const posBack1 = -0.2;
    const posZero = 0;
    const posFront1 = 0.2;
    const posFront2 = 0.4;
    const posFront3 = 0.6;
    const posFront4 = 0.8;

    const radiusBack4 = 0.5;
    const radiusBack3 = 0.7;
    const radiusBack2 = 0.85;
    const radiusBack1 = 0.95;
    const radiusZero = 1;
    const radiusFront1 = 1.1;
    const radiusFront2 = 1.2;
    const radiusFront3 = 1.4;
    const radiusFront4 = 1.7;

    this.shiftXRight = [ 0, 1, 11, 12, 13, 14, 15, 16, 17, 29 ]
    this.shiftXHalf = [30]

    this.circles = [
      {id: 0, cx: -404.6, cy: -481.3, z: 0},
      {id: 1, cx: 646.6, cy: -471.3, z: 0},
      {id: 2, cx: 786.3, cy: -509.4, z: 0},
      {id: 3, cx: 936.3, cy: -490, z: 0},
      {id: 4, cx: 754.9, cy: -384, z: 0},
      {id: 5, cx: 1667.4, cy: -650.5, z: 0},
      {id: 6, cx: 2402.7, cy: -388.8, z: 0},
      {id: 7, cx: 2506.4, cy: 209.1, z: 0},
      {id: 8, cx: 1788.3, cy: 487.7, z: 0},
      {id: 9, cx: 2512.9, cy: 1191.5, z: 0},
      {id: 10, cx: 1343.9, cy: 852, z: 0},
      {id: 11, cx: 92.8, cy: 905.7, z: 0},
      {id: 12, cx: -547.4, cy: 687.3, z: 0},
      {id: 13, cx: -477.7, cy: 455.5, z: 0},
      {id: 14, cx: -477.7, cy: 348, z: 0},
      {id: 15, cx: 0.2, cy: 274.3, z: 0},
      {id: 16, cx: 62, cy: 378.5, z: posZero, radius: radiusZero, imageUrl: 'img-1.png'},
      {id: 17, cx: -112.5, cy: 508.9, z: 0},
      {id: 18, cx: 848.9, cy: 895.6, z: posBack3, radius: radiusBack3, imageUrl: 'img-7.png'},
      {id: 19, cx: 910.8, cy: 654.6, z: posBack1, radius: radiusBack1, imageUrl: 'img-0.png'},
      {id: 20, cx: 1092.9, cy: 723.2, z: posFront3, radius: radiusFront3, imageUrl: 'img-6.png'},
      {id: 21, cx: 1524.9, cy: 714.7, z: posBack4, radius: radiusBack4, imageUrl: 'img-10.png'},
      {id: 22, cx: 1602.2, cy: 225.1, z: posFront2, radius: radiusFront2, imageUrl: 'img-8.png'},
      {id: 23, cx: 1188.6, cy: 187.9, z: posFront1, radius: radiusFront1, imageUrl: 'img-4.png'},
      {id: 24, cx: 1412.2, cy: 85.4, z: posFront4, radius: radiusFront4, imageUrl: 'img-9.png'},
      {id: 25, cx: 880.3, cy: 138.7, z: posBack2, radius: radiusBack2, imageUrl: 'img-1.png'},
      {id: 26, cx: 1093.7, cy: 45.6, z: posBack1, radius: radiusBack1, imageUrl: 'img-12.png'},
      {id: 27, cx: 599.8, cy: 192.7, z: 0},
      {id: 28, cx: 783.7, cy: 210.7, z: posBack4, radius: radiusBack4, imageUrl: 'img-8.png'},
      {id: 29, cx: 72.2, cy: 95.5, z: posBack1, radius: radiusBack1, imageUrl: 'img-10.png'}, // 72.2
      {id: 30, cx: 420, cy: 107, z: posFront3, radius: radiusFront3, imageUrl: 'img-6.png'},
    ];

    this.assetsManager = new LoadingManager();

    this.assetsManager.crossOrigin = "";
    this.assetsManager.onLoad = () => {
      this.initObjects();
    };
    this.textureLoader = new TextureLoader(this.assetsManager);

    for (let i = 0; i < this.circles.length; i++) {
      if (this.circles[i].imageUrl) {
        this.circles[i].map = this.textureLoader.load(this.imagePath + this.circles[i].imageUrl);
      }
    }
  }

  adjustCoordinatesX(point) {
    if (this.shiftXHalf.includes(point.id)) {
      return point.cx + 120;
    } else if (!this.shiftXRight.includes(point.id)) {
      return point.cx + 350;
    } else {
      return point.cx - 70;
    }
  }

  initLines() {
    this.lines = [];
    let vertexesRelation = {
      0: [29],
      1: [29],
      2: [27],
      3: [27],
      4: [26],
      5: [24],
      6: [22, 24],
      7: [22],
      8: [22, 21],
      9: [21],
      10: [21, 20, 23],
      11: [12, 17],
      13: [17],
      14: [15],
      15: [16, 29],
      16: [17],
      18: [20],
      19: [20, 22],
      20: [22, 26],
      22: [23],
      23: [24, 25, 26],
      24: [25],
      25: [26, 27, 28, 30],
      29: [30],
    };

    const material = new LineMaterial({
      color: 0xffffff,
      linewidth: 1,
      resolution: new Vector2(640, 480)
    });

    for (let vertexId in vertexesRelation) {
      let connectedVertexes = vertexesRelation[vertexId];
      connectedVertexes.forEach(connectedVertexId => {
        let vertex1 = this.vertexes[vertexId];
        let vertex2 = this.vertexes[connectedVertexId];

        const lineGeometry = new LineGeometry();
        lineGeometry.setPositions([vertex1.x, vertex1.y, vertex1.z, vertex2.x, vertex2.y, vertex2.z]);
        const line = new Line2(lineGeometry, material);
        line.computeLineDistances();

        this.sceneGroup.add(line);
        this.lines.push(line);
      });
    }
  }

  initMouseMove() {
    this.mouseX = 0;
    this.mouseY = 0;
    if (!this.autoRotate) {
      this.root.addEventListener('mousemove', (event) => {

        this.mouseX = Math.round(((event.clientX - this.rootWidthHalf) / this.rootWidth) * 100) / 100;
        this.mouseY = Math.round(((event.clientY - this.rootHeightHalf) / this.rootHeight) * 100) / 100;
      });
    }
  }

  render() {
    if (this.autoRotate) {
      this.mouseX = Math.sin(this.autoRotateAngle) * this.deltaAspect * .7;
      this.mouseY = Math.cos(this.autoRotateAngle) * this.deltaAspect * .7;
      this.autoRotateAngle += this.autoRotateSpeed;
    }

    this.scene.rotation.x = Math.round(MathUtils.lerp(this.scene.rotation.x, (this.mouseY * Math.PI) / 30, 0.1) * 10000) / 10000;
    this.scene.rotation.y = Math.round(MathUtils.lerp(this.scene.rotation.y, (this.mouseX * Math.PI) / 30, 0.1) * 10000) / 10000;
    this.renderer.render(this.scene, this.camera);

    requestAnimationFrame(this.render.bind(this));
  }

  handleResize() {
    setTimeout(() => {
      this.resize();
    }, 1000);

    window.addEventListener("resize", () => {
      this.resize();
    });
  }

  updateGroup() {
    if(this.sceneGroup) {
      if (this.deltaAspect > 1.25) {
        this.sceneGroup.position.set(-1.75, this.deltaAspect * 1.5 , 0);
      } else if (this.deltaAspect > 1.05) {
        this.sceneGroup.position.set(-1.75, 1.2, 0);
      } else if (this.deltaAspect > 0.95) {
        this.sceneGroup.position.set(-1.75, 1, 0);
      } else {
        this.sceneGroup.position.set(-1.7, 0, 0);
      }
    }
  }

  resize() {
    const width = window.innerWidth;
    if (width !== this.rootWidth) {
      this.rootWidth = this.root.offsetWidth;
      this.rootHeight = this.root.offsetHeight;
      this.rootWidthHalf = this.rootWidth / 2;
      this.rootHeightHalf = this.rootHeight / 2;
      if (this.camera) {
        const originalAspect = this.originalRect.width / this.originalRect.height;
        const aspect = this.rootWidth / this.rootHeight;
        this.deltaAspect = originalAspect / aspect;
        if(this.deltaAspect < 1.5) {
          this.camera.position.set(0, 0, 7 * this.deltaAspect);
        } else {
          // this.camera.position.set(0, 0, 7 * this.deltaAspect);
          this.camera.position.set(0, 0, 13 - this.deltaAspect * 0.05);
        }
        this.camera.aspect = aspect;
        this.renderer.setSize(this.rootWidth, this.rootHeight);
        this.camera.updateProjectionMatrix();
        this.updateGroup()
      }
    }
  }
}

export default HeroA16ZPodcastShow;

/* eslint-enable */
